import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error Boundary caught an error:", error, errorInfo);
    
    this.clearAllCookies();
    this.clearStorageAndSetLogin();
    
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  clearAllCookies = () => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  };

  clearStorageAndSetLogin = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("currScreen", "Login"); 
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          height: "100vh",
          flexDirection: "column"
        }}>
          <h2>Something Went Wrong</h2>
          <p>Redirecting to login page...</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;